import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AgencyService } from "src/app/agency/services/agency.service";
import { Helpers } from "src/helpers/helpers";
import { Agency } from "src/models/agency";
import { AccountService } from "src/services/account.service";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";

@Component({
  selector: "app-careplus-help-section",
  templateUrl: "./careplus-help-section.component.html",
  styleUrls: ["./careplus-help-section.component.css"],
})
export class CareplusHelpSectionComponent {
  agency?: Agency;
  hasCareplusProduct: boolean = false;

  constructor(
    private agencyService: AgencyService,
    private helper: Helpers,
    private accountService: AccountService,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    this.agencyService.getAgency().subscribe((agency) => {
      this.agency = agency;
    });
    const products = this.helper.getProducts();
    this.hasCareplusProduct = products.some(
      (p) => p.toLowerCase() === "careplus",
    );

    const userType = this.helper.getDecodedAccessToken(
      window.localStorage.token,
    ).type;
    if (
      userType.indexOf("LEVEL 0") === 0 ||
      userType.indexOf("LEVEL 1") === 0 ||
      userType.indexOf("LEVEL 2") === 0
    ) {
      this.accountService.getAccount().subscribe((data) => {
        if (!data.activated) {
          this.helper.logout();
          this.router.navigate(["/"]);
          this.snackBar.open(
            "Your account is not active, please contact admin.",
            "Close",
            {
              duration: 3000,
            },
          );
        }
      });
    }
  }
}
